import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import ManagementTable from '../../components/ManagementTable';
import ReviewProviderForm from '../../forms/ReviewProviderForm';

const ReviewProviders = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Review Providers"
      addTitle="Add New Provider"
      editTitle="Edit Provider"
      columns={[
        {title: 'Name', field: 'name'},
        {title: 'Link', field: 'url'}
      ]}
      loadData={async (query) => services.reviewProvider.getTableProviders(query)}
      renderForm={(props, provider, onSaved) => (
        <ReviewProviderForm
          {...props}
          provider={provider ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  )
}

export default ReviewProviders;
